export default __webpack_public_path__ + "static/media/Add.c18c1dbb.svg";